<template>
    <div class="container">
        <h3>PathEditor组件</h3>
        <ul>
            <li v-for="(pos,index) in positions" :key="index" @click="itemClicked(index)" 
                :class="{active:currentSelectedLine == index}">
                <h3>{{ index }} - {{ pos.lon }} - {{ pos.lat }}</h3>
                
            </li>
        </ul>
        <button @click="deletePoint">删除坐标点</button>
        <button @click="insertPoint">插入坐标点前面</button>
        <button @click="saveFile">保存到文件中</button>
    </div>
</template>

<script>
import  fs  from 'fs';
export default {
    name:'PathEditor',
    props:['mouseLeftClickPosition','getPathPoints'],
    data(){
        return {
            positions:[],
            insertPos:-1,//新的坐标要在哪里插入，-1表示插到positions末尾
            currentSelectedLine:-1, // 当前被选中的行
            id:0,
        }
    },
    watch:{
        mouseLeftClickPosition:{
            handler(newVal){
                newVal.ati = 100;
                newVal.result = null ;
                newVal.time = null;
                newVal.deviceid = 2922;
                newVal.speed = 100;
                if(this.insertPos<0)
                    this.positions.push({lon:newVal.longitude,lat:newVal.latitude,
                                         ati:newVal.ati,result:newVal.result,
                                         time:newVal.time,deviceid:newVal.deviceid,
                                         speed:newVal.speed,deviceid:newVal.deviceid});
                else{
                    this.positions.splice(++this.currentSelectedLine, 0, {lon:newVal.longitude,lat:newVal.latitude,
                                                                          ati:newVal.ati,result:newVal.result,
                                                                          time:newVal.time,deviceid:newVal.deviceid,
                                                                          speed:newVal.speed,deviceid:newVal.deviceid});
                }

                //Iso8601时间的格式是："2021-08-03T00:00:00Z"    
                let secondsOfDay = Cesium.JulianDate.fromIso8601("2021-08-03T00:00:00Z").secondsOfDay;//起始时间
                let day = Cesium.JulianDate.fromIso8601("2021-08-03T00:00:00Z").dayNumber;
                //以上JulianDate的格式是Cesium.TimeStandard.TAI
                let speed = 100;//匀速运动的速度

                this.positions[0].id=0;
                this.positions[0].speed=speed;//因为是匀速运动，所有speed都一样
                let t = new Cesium.JulianDate(day,secondsOfDay, Cesium.TimeStandard.TAI);
                this.positions[0].time= Cesium.JulianDate.toIso8601(t);//起始时间
                for(let i=1 ; i < this.positions.length ; i++){
                    let pos = this.positions[i-1];
                    let lastP = this.positions[i];
                    let firstPos = {lon:pos.lon,lat:pos.lat,h:pos.ati};
                    let lastPos = {lon:lastP.lon,lat:lastP.lat,h:lastP.ati};
                    let distance = this.getSpaceDistance(firstPos,lastPos);// 单位为：米
                    secondsOfDay = secondsOfDay + (distance / speed);
                    t = new Cesium.JulianDate(day,secondsOfDay, Cesium.TimeStandard.TAI);
                    this.positions[i].time = Cesium.JulianDate.toIso8601(t);   
                    this.positions[i].id= i;
                    this.positions[i].distance = distance ;
                    if(this.currentSelectedLine == i){
                        this.positions[i].isSelected = true ;
                    }else{
                        this.positions[i].isSelected = false ;
                    }
                }
                this.getPathPoints(this.positions);
                
                console.log('this.positions=',JSON.stringify(this.positions));
            }
        }
        
    },
    methods:{
        itemClicked(index){
            console.log('itemClicked = ',index );
            this.currentSelectedLine = index ;
            this.positions.forEach(element=>{
                if(this.currentSelectedLine == element.id){
                    element.isSelected = true ;
                }else{
                    element.isSelected = false ;
                }   
            })
            this.getPathPoints(this.positions);
        },
        deletePoint(){
            this.positions.splice(this.currentSelectedLine, 1);
            // console.log('delete point = ',this.positions);
            for(let i=0 ; i<this.positions.length ; i++){
                this.positions[i].id = i ;
            }
            this.getPathPoints(this.positions);
            
        },
        insertPoint(){
            this.insertPos = 1
            // this.positions.splice(this.currentSelectedLine, 0, 'Feb');
            
        },
        saveFile(){
            // 准备要写入的数据
            const data = this.positions;
            // 写入数据到文件中
            fs.writeFile('./example.json', JSON.stringify(data), (err) => {
                if (err) {
                    console.error(err);
                } else {
                    console.log('文件写入成功！');
                }
            });
        },
        //firstPos,lastPos为存放经纬度坐标
        getSpaceDistance(firstPos,lastPos) {
            var point1cartographic = Cesium.Cartographic.fromDegrees(firstPos.lon, firstPos.lat, firstPos.h);
            var point2cartographic = Cesium.Cartographic.fromDegrees(lastPos.lon, lastPos.lat, lastPos.h);
            /**根据经纬度计算出距离**/
            var geodesic = new Cesium.EllipsoidGeodesic();
            geodesic.setEndPoints(point1cartographic, point2cartographic);
            var s = geodesic.surfaceDistance;
            //返回两点之间的距离
            s = Math.sqrt(
                Math.pow(s, 2) +
                Math.pow(point2cartographic.height - point1cartographic.height, 2)
            );
            return s;
        }
    }

}
</script>

<style scoped>
.container{
    position: absolute;
    top: 2%;
    left: 70%;
}
ul{
    height: 750px;
    overflow: scroll;
}
li{
    color: rgb(10, 5, 145);
}
.active{
    color: brown;
}
</style>